const STORAGE_KEY = 'bannerDismissals';
export type DismissRecord = {
  [equipmentId: string]: {
    [bannerType: string]: number;
  };
};

export enum BannerType {
  SUBSCRIPTION_EXPIRES_SOON = 'SUBSCRIPTION_EXPIRES_SOON',
  SUBSCRIPTION_UNLOCK_FEATURES = 'SUBSCRIPTION_UNLOCK_FEATURES',
}

export function getDismissals(): DismissRecord {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

export function recordDismiss(
  equipmentId: string,
  bannerType: BannerType,
  ts = Date.now(),
) {
  const data = getDismissals();
  data[equipmentId] = data[equipmentId] || {};
  data[equipmentId][bannerType] = ts;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getLastDismissAt(
  equipmentId: string,
  bannerType: BannerType,
): number | undefined {
  const data = getDismissals();
  return data?.[equipmentId]?.[bannerType];
}
